import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Icon, IconButton } from '@fashionnovateam/nova-ui-toolkit';
import styles from './Drawer.module.css';
import Stepper from '../../../Stepper/Stepper';
import { ActionButton } from '../../Buttons/Buttons';
import VendorTypeLabels from '../../../../../Lib/Constants/vendor-types.ts';

function Drawer({
  currentUser,
  vendorApplication = null,
  stepper,
  onNavigationClick = () => {},
  logout,
  editButton = false,
  onEditButtonClick,
}) {
  const handleLogout = useCallback(() => {
    logout();
  }, [logout]);

  return (
    <div className={styles.drawer}>
      <div className={styles.drawerBody}>
        <div className={styles.profileContainer}>
          {vendorApplication && vendorApplication.vendor_name && (
            <div className="twp flex gap-2">
              <div>
                <div className={styles.name}>
                  {vendorApplication.vendor_name}
                </div>
                <div className={styles.role}>
                  {VendorTypeLabels[vendorApplication.vendor_type]}
                </div>
              </div>
              <div className="mt-5">
                {editButton && (
                  <IconButton
                    onClick={onEditButtonClick}
                    color="secondary"
                    className="border-neutral-300 rounded-lg h-7 w-7 min-w-7 min-h-7 p-1.5"
                    icon={<Icon.PencilEditSwoosh style={{ fill: 'none' }} />}
                    data-testid="edit-vendor-profile-button"
                  />
                )}
              </div>
            </div>
          )}
          {currentUser.vendor && (
            <div className={styles.logoutContainer}>
              <ActionButton onClick={handleLogout}>Logout</ActionButton>
            </div>
          )}
        </div>
        <Stepper
          steps={stepper.steps}
          activeStep={stepper.activeStep}
          displayedStep={stepper.displayedStep}
          onClick={onNavigationClick}
          editMode={stepper.editMode}
          isSecondExecutiveApproved={stepper.isSecondExecutiveApproved}
        />
      </div>
    </div>
  );
}

Drawer.propTypes = {
  currentUser: PropTypes.shape({
    email: PropTypes.string,
  }).isRequired,
  vendorApplication: PropTypes.shape({
    vendor_name: PropTypes.string,
    vendor_type: PropTypes.string,
  }),
  stepper: PropTypes.shape({
    steps: PropTypes.arrayOf(PropTypes.string),
    currentStep: PropTypes.number,
    displayedStep: PropTypes.number,
    editMode: PropTypes.bool,
    isSecondExecutiveApproved: PropTypes.bool,
  }).isRequired,
  onNavigationClick: PropTypes.func,
  logout: PropTypes.func.isRequired,
  editButton: PropTypes.bool,
  onEditButtonClick: PropTypes.func,
};

export default Drawer;
